import { getAnyZoneTime, goJoinEvent } from "@/lobby_common/utils/utils";
export default {
  name: "EventModal",
  components: {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      getAnyZoneTime,
      lang: this.$store.getters.getLang,
      arrowImg: require("@/assets/home/btn_left.png"),
      closeBtn: require(`@/assets/charge/guanbi1_btn.png`),
      imgHeight: 400,
    };
  },
  filters: {},
  computed: {
    taken() {
      return this.$store.getters.taken;
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    iconUrl() {
      return this.$store.getters.getPacketDomain?.webHotUpdateUrl;
    },
  },
  async created() {},
  mounted() {
    if (this.isMobile()) {
      this.slideBanner();
    }
  },
  methods: {
    arrowClick(type) {
      if (type === "right") {
        this.$refs.activityCarousel?.next();
      } else {
        this.$refs.activityCarousel?.prev();
      }
    },
    clickFun(item) {
      this.$popConfig.endWinConfig();
      const jump = item.jump || {};
      this.$emit("close", true);
      const isFirst = item.sid === this.list[0].sid;
      this.$eventPost("tpgn_notice_ok", {
        pop_type: item.dialogType,
        name: isFirst ? item.name : "",
        ruleName: item.ruleName || "",
        ruleSid: item.ruleSid || "",
        jump_value: jump,
      });
      this.$eventPost("click", {
        eid: `119_0_0_119002`,
        time: Date.now(),
        pop_type: item.dialogType,
        name: item.name || "",
        ruleName: item.ruleName || "",
        ruleSid: item.ruleSid || "",
        jump_value: jump,
      });
      goJoinEvent(jump);
    },
    onGoRegister() {
      this.$popConfig.endWinConfig();
      this.$emit("close", true);
      this.$eventPost("click", {
        eid: `119_0_0_119001`,
        time: Date.now(),
        pop_type: this.list[0].dialogType,
        name: this.list[0].name || "",
        ruleName: this.list[0].ruleName || "",
        ruleSid: this.list[0].ruleSid || "",
        jump_value: {
          type: "Jump_TYPE_FUNCTION",
          functionType: "JUMP_FUNCTION_TYPE_REGISTER",
        },
      });
      // 去注册
      this.$Bus.$emit("showLogin");
    },
    isMobile() {
      // match方法可在字符串内检索指定的值，
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    slideBanner() {
      // 选中的轮播图
      var box = document.querySelector(".activity-lunbo");
      var startPoint = 0;
      var stopPoint = 0;
      // 重置坐标
      var resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      };
      // 手指按下
      box.addEventListener("touchstart", function (e) {
        // 手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      // 手指滑动
      box.addEventListener("touchmove", function (e) {
        // 手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      // 当手指抬起的时候，判断图片滚动离左右的距离
      const that = this;
      box.addEventListener("touchend", function (e) {
        if (stopPoint === 0 || startPoint - stopPoint === 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.activityCarousel?.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.activityCarousel?.prev();
          return;
        }
      });
    },

    getNotice(languages) {
      let img = "";
      if (this.getIsMobile) {
        img = this.iconUrl + languages.smallImg;
      } else {
        img = this.iconUrl + languages.img;
      }
      return img;
    },
    close() {
      const item = this.list[0] || {};
      this.$eventPost("tpgn_notice_close", {
        pop_type: item.dialogType,
        name: item.name || "",
        ruleName: item.ruleName || "",
        ruleSid: item.ruleSid || "",
      });
      this.$emit("close", false);
    },
    imgLoad() {
      // console.log(this.slides , 'this.slides')
      if (this.list.length > 0) {
        this.$nextTick(() => {
          const ref = this.$refs;
          this.imgHeight =
            ref.imageRef && ref.imageRef.length ? ref.imageRef[0].height : "";
          // console.log(this.imgHeight, "  this.imgHeight ");
        });
      }
    },
  },
};
